import { Chip } from "@mui/material";

interface OfferTypeProps {
  type: string;
}

export default function OfferType({ type }: OfferTypeProps) {
  return <Chip label={type} color="primary" />;
}
